import {lazy} from 'react'
import {Navigate} from 'react-router-dom'
const Test = lazy(()=>import('../views/test'))

const router=[
    // These are the same as the props you provide to <Route>
    { path: "/pay", element: <Test /> },
    { path: "/",element:<Navigate to="/pay"/> }
]
export default router